import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Account } from '../../pages/account/account';
import { Authentication } from '../model/authentication';
import { Accounts } from '../util/accounts';
import { AbstractApiService } from './abstract-api-service';

@Injectable({
	providedIn: 'root',
})
export class AuthService extends AbstractApiService {
	public currentAccount: Observable<Account>;
	private currentAccountSubject: BehaviorSubject<Account>;

	constructor(protected http: HttpClient) {
		super(http);
		this.currentAccountSubject = new BehaviorSubject<Account>(Accounts.getAccount());
		this.currentAccount = this.currentAccountSubject.asObservable();
	}

	public get currentMemeberValue(): Account {
		return this.currentAccountSubject.value;
	}

	get prefix(): string {
		return 'a/auth';
	}

	login(id: string, pw: string): Observable<any> {
		return this.post('', { authId: id, pw: pw }).pipe(
			map((res) => {
				if (res && res.result) {
					const authentication = new Authentication(res.data);
					Accounts.setAccount(authentication.account);
          if (authentication.tokenId) Accounts.setTokenId(authentication.tokenId);
					if (authentication.accessToken) Accounts.setToken(authentication.accessToken);
					if (authentication.refreshToken) Accounts.setRefreshToken(authentication.refreshToken);
					this.currentAccountSubject.next(authentication.account);
				}
				return res;
			}),
		);
	}

	refreshToken(): Observable<any> {
		return this.post('refresh-token').pipe(
			tap((res) => {
				if (res && res.result) {
					const authentication = new Authentication(res.data);
					
					if (authentication.accessToken) Accounts.setToken(authentication.accessToken);
					if (authentication.refreshToken) Accounts.setRefreshToken(authentication.refreshToken);
				} else {
					Accounts.clearAll();
				}
			}),
		);
	}

	logout(): Observable<any> {
		return this.post('logout').pipe(
			map((response) => {
				Accounts.clearAll();
				this.currentAccountSubject.next(null);
			}),
		);
	}

}
